export enum ExportFormat {
  ShapeFile,
  GeoJson
}
